import { useEffect, useState } from 'react';

/**
 * Reports an element's layout box in pixels.
 *
 * offsetWidth/Height rather than getBoundingClientRect: a rotated shape would
 * otherwise report its inflated axis-aligned bounds and distort the geometry.
 * ResizeObserver is guarded because jsdom does not implement it.
 */
export const useMeasuredSize = (ref) => {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const measure = () => {
      const width = el.offsetWidth;
      const height = el.offsetHeight;
      setSize((prev) =>
        prev.width === width && prev.height === height ? prev : { width, height }
      );
    };

    measure();

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(measure);
      observer.observe(el);
      return () => observer.disconnect();
    }
    return undefined;
  }, [ref]);

  return size;
};

export default useMeasuredSize;
